import React from 'react';

import Table from 'components/Table';

import deleteIcon from 'assets/icons/trash.svg';

import {formatDate} from 'utils/datetime';
import {openUrlInNewTab} from 'utils/files';

const TableRow = ({doc, deleteDocument}) => (
  <Table.Row className="KycDocumentsTableRow">
    <Table.Cell
      className="documentPreview"
      onClick={() => openUrlInNewTab(doc.url)}>
      {doc.filename}
    </Table.Cell>
    <Table.Cell>{doc.type}</Table.Cell>
    <Table.Cell>{formatDate(doc.createdAt)}</Table.Cell>
    <Table.Cell>{doc.addedBy}</Table.Cell>
    <Table.Cell
      className="detail"
      onClick={() =>
        deleteDocument({
          kycDocumentId: doc.identifier,
          kycDocumentName: doc.filename
        })
      }>
      <img src={deleteIcon} alt="Delete" />
    </Table.Cell>
  </Table.Row>
);

const KycDocumentsTable = ({
  documents,
  sectionLabel,
  deleteDocument = () => {}
}) => (
  <div className="KycDocumentsTable KycTable">
    <div className="tableHeading">{sectionLabel} documents</div>
    <Table>
      <Table.Header>
        <Table.HeaderItem heading="filename" />
        <Table.HeaderItem heading="type" />
        <Table.HeaderItem heading="uploaded" />
        <Table.HeaderItem heading="uploaded by" />
        <Table.HeaderItem className="detail" />
      </Table.Header>
      <Table.Body>
        {documents.map(doc => (
          <TableRow
            key={doc.identifier}
            doc={doc}
            deleteDocument={deleteDocument}
          />
        ))}
      </Table.Body>
    </Table>
  </div>
);

export default KycDocumentsTable;
